let shop = {
    path: "shop",
    name: "shop",
    redirect: "/shop/strategy",
    component: () => import("@/views/shop/index.vue"),
    children: [
        {
            path: "strategy",
            name: "strategyList",
      component: () => import("@/views/shop/pages/strategy.vue"),
            meta: {
                name: "价格策略",
            },
        },
        {
            path: "newStrategy",
            name: "newStrategyName",
      component: () => import("@/views/shop/pages/newStrategy.vue"),
            meta: {
                name: "新建价格策略",
            },
        },
        {
            path: "inventory",
            name: "inventoryName",
      component: () => import("@/views/shop/pages/inventory.vue"),
            meta: {
                name: "商品库存",
            },
        },

    
    ],
};

export default shop;
